import React from 'react';
import UcodeLogin from './Ucode/UcodeLogin'


const NoMatch = () => (<UcodeLogin hideButton={true} />);
export default NoMatch;